import React from 'react'
import { useParams } from 'react-router-dom'
import { HttpStatus } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// components
import SalonPage from '../pages/SalonPage/SalonPage'

// types
import { ContextProps } from '../types/types'

// helpers
import useZodQueryParams from '../hooks/useZodQueryParams'

// utils
import { salonPageQuerySchema } from '../utils/zodQuerySchemas'

type SalonRouteParams = {
	salonSlug: string
}

const SalonRoute: React.FC<React.PropsWithChildren<ContextProps>> = (props) => {
	const { salonSlug } = useParams<SalonRouteParams>()

	const [query, setQuery] = useZodQueryParams(salonPageQuerySchema)

	if (!salonSlug) {
		return <HttpStatus status={404}>{null}</HttpStatus>
	}

	return <SalonPage {...props} salonSlug={salonSlug} query={query} setQuery={setQuery} />
}

export default SalonRoute
